import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Location } from '@angular/common';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { Cargo } from '../../../models/cargo.model';
import sortBy from 'sort-by';

@Component({
  selector: 'app-pre-visualizar-eleicao',
  templateUrl: './pre-visualizar-eleicao.component.html',
  styleUrls: ['./pre-visualizar-eleicao.component.css']
})
export class PreVisualizarEleicaoComponent implements OnInit {
  eleicaoParametrizacao: any;
  cargos: Cargo[];
  cargoSelecionado: Cargo;
  idCargoSelecionado: Number;
  labelSelecao: string;
  temCandidaturas: boolean;
  constructor(
    public spinner: NgxSpinnerService,
    private location: Location,
    protected eleicaoService: EleicaoService,
  ) { }

  ngOnInit() {
    this.eleicaoParametrizacao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    this.temCandidaturas = this.eleicaoParametrizacao.temCandidaturas;
    const token = sessionStorage.getItem("token");
    if (this.eleicaoParametrizacao && this.eleicaoParametrizacao.id) {
      this.obterCargos(this.eleicaoParametrizacao.id, token);
    }

  }
  voltar() {
    sessionStorage.removeItem("eleicaoClicadaParametrizacao");
    this.location.back();
  }

  obterCargos(idEleicao, token) {
    this.eleicaoService.getCargosByIdEleicao2(idEleicao, token).then((response: Cargo[]) => {
      this.cargos = response;
      if (this.cargos && this.cargos.length > 0) {
        if (this.temCandidaturas)
          this.cargos.forEach(c => {
            c.candidatos = c.candidatos.sort(sortBy('nome'));
          })
        this.cargoSelecionado = this.cargos[0];
        this.labelSelecao = this.cargoSelecionado.labelCargo;
      }
      this.spinner.hide();
    });
  }

  selecionarCargo(idCargo) {
    this.cargoSelecionado = this.cargos.find(cargo => cargo.id == idCargo);
  }
}
